import * as React from 'react';
import { styled } from '@mui/material/styles';
import { useTheme } from '@mui/material/styles';
import { darken, lighten, alpha, Typography } from "@mui/material";

import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';

import ButtonBase from '@mui/material/ButtonBase';
import {isNullOrNaN} from '../../Bs4Components/Bs4Utils';

import {   
  // TYPE_NAVIGATION,
  // TYPE_CALENDAR,
  // TYPE_AGENDE,
  TYPE_SCHEDULER,
  TYPE_MODIFIER,

  VIEW_TYPE_YEAR,
  VIEW_TYPE_MONTH,
  VIEW_TYPE_WEEK,
  VIEW_TYPE_DAY,

  VIEW_TYPE_MODIFIER_LAYER0,
  VIEW_TYPE_MODIFIER_LAYER1,
  VIEW_TYPE_MODIFIER_ADJUSTMENT_TO_UNIT_WIDTH,

  ATRYBUT_SCHED_SHOWEXACT,
  ATRYBUT_SCHED_SHOWFIXED,
  // ATRYBUT_SCHED_SHOWYEAR,
  // ATRYBUT_SCHED_SHOWMONTH,
  // ATRYBUT_SCHED_SHOWWEEK,
  // ATRYBUT_SCHED_SHOWDAY,

  footerButtons,
  isSelected,

} from './Bs4ReportCalendarConst'

import Bs4MainDispatch from '../../Bs4MainDispatch';
import Bs4Kartoteka from '../../Bs4Kartoteka';
import Bs4ViewFooter from '../Bs4ReportViewFooter';
import CircularProgress from '@mui/material/CircularProgress';

import { ViewBs4EventDragOverlay, ViewBs4EventDraggable, ViewBs4Event } from './Bs4ReportTimelineViewBs4Event'
import * as Bs4Utils from '../../Bs4Components/Bs4Utils'
import { getBoxSx, getBoxStyle } from '../../Bs4Theme/Bs4UxTemplates';
import { SmallScreenContext, useStateUxTemplate } from '../../Bs4Theme/Bs4UxTemplates';

import { DndContext, useDndMonitor, useDroppable, useDraggable, DragOverlay } from '@dnd-kit/core';
// import {closestCorners, closestCenter, rectIntersection} from '@dnd-kit/core';
import { MouseSensor, TouchSensor, KeyboardSensor, PointerSensor, useSensor, useSensors } from '@dnd-kit/core';
import { v4 as uuidv4 } from 'uuid';

import {  
  add,
  addHours, startOfHour, endOfHour,
  addDays, startOfDay, endOfDay,
  addWeeks, startOfWeek, endOfWeek,  
  addMonths, startOfMonth, endOfMonth,
  addYears, startOfYear, endOfYear,
  compareAsc, compareDesc,
  eachHourOfInterval, eachDayOfInterval, eachWeekOfInterval, eachWeekendOfInterval, eachMonthOfInterval, eachYearOfInterval,
  format,
  // areIntervalsOverlapping,
  getDaysInMonth,
  differenceInMilliseconds, differenceInMinutes, differenceInDays,
  addMilliseconds,
  max, min,
  getWeek,
  differenceInCalendarYears, differenceInCalendarMonths, differenceInCalendarDays, differenceInCalendarWeeks, differenceInHours,
  roundToNearestMinutes,
} from "date-fns";

import Bs4ViewAvatar from '../../Bs4Components/Bs4ViewAvatar';

const HeaderButton = styled(ButtonBase)(({ theme }) => ({ 
  '&:hover, &.Mui-focusVisible': {
    backgroundColor: '#00000007'
  },
}));

const DROPPABLE = 'droppable';
const DRAGGABLE = 'draggable';

const arrayRemoveElement = (array, element, msg) => {
  if (!Array.isArray(array)) return null;
  if (!element) return null;

  const i = array.indexOf(element);
  if (i < 0) {    
    //console.log(msg+'<0', array, element, i);
    return null;
  }
  const e = array.splice(i, 1).pop();
  if (element !== e) {
    //console.log(msg+'!=', array, element, e, i);
    return null;
  }
  return e;
}

const arrayAddElement = (array, element) => {
  if (!Array.isArray(array)) return null;
  if (!element) return null;
  array.push(element);
  return element
};

export const todayBorder = '3px dashed #ff000022';

export default class Bs4ReportTimeline {

  constructor(initialValues) {
    this.initialValues = initialValues
    this.bs4Timeline.viewType = this.initialValues.viewType;
    this.bs4Timeline.adjustmentToUnitWidth = this.initialValues.adjustmentToUnitWidth;    
    this.formId = this.initialValues.formId;
    this.bs4Timeline.bs4EventHeight = this.initialValues.bs4rowheight || this.bs4Timeline.bs4EventHeight;
    this.bs4Timeline.nearestTo = this.initialValues.minInterval;    
  }  

  reload = () => {
    console.log('...bs4Timeline...reload...');
    this.resetColumnsMenu();
    this.loadData();
  }

  ScrollContext = React.createContext({});

  borderColor = '#00000011';
  borderWidth = 1;
  selectColor = '#00000008';

  bs4Timeline = {
    viewType: VIEW_TYPE_WEEK,
    adjustmentToUnitWidth: true,
    layer0: true,
    layer1: true,
    date: new Date(),
    start: null,    
    end: null,
    startData: null,
    endData: null,
    headerArray: [],
    resourceArray: [],
    columnMenuArray: [],
    apiDict: {},
    nearestTo: 5,

    bs4EventHeight: 40,
    scrollMargin: 5,

    borderColor: this.borderColor,
    borderWidth: this.borderWidth,
    selectColor: this.selectColor,
  
    borderStart: {
      borderLeft: `solid ${this.borderColor}`, 
      borderTop: `solid ${this.borderColor}`,     
      borderWidth: this.borderWidth,
    },

    borderLeft: {
      borderLeft: `solid ${this.borderColor}`, 
      borderWidth: this.borderWidth,
    },

    borderEnd: {
      borderRight: `solid ${this.borderColor}`, 
      borderBottom: `solid ${this.borderColor}`,
      borderWidth: this.borderWidth,
    },

    bs4Select: (bs4Event) => {
      Bs4MainDispatch.commandParser('Bs4CalendarAdd', {
        resTargetId: bs4Event.ResourceId,
        EventSchStart: Bs4Utils.toDateTime(bs4Event.start), 
        EventSchEnd: Bs4Utils.toDateTime(bs4Event.end),
        currFormId: this.formId,
      },  this.bs4KartotekaId);
    },
  
    bs4EventResize: (eventProps) => {
      Bs4MainDispatch.commandParser('Bs4CalendarMove', {              
        resTargetId: eventProps.bs4Event.ResourceId,
        EventSchId: eventProps.bs4Event.id, 
        EventSchStart: Bs4Utils.toDateTime(eventProps.bs4Event.start), 
        EventSchEnd: Bs4Utils.toDateTime(eventProps.bs4Event.end) , 
        resTargetId : eventProps.bs4Event.ResourceId,
        currFormId: this.formId,
      }, this.bs4KartotekaId);
    },
  
    bs4EventDrop: (bs4Event, resource) => {        
      Bs4MainDispatch.commandParser('Bs4CalendarMove', {
        // resTargetId: eventDropInfo.newResource?.id || null, 
        // EventSchId: eventDropInfo.oldEvent.id, 
        resTargetId: resource.Id,
        EventSchId: bs4Event.id, 
        EventSchStart: Bs4Utils.toDateTime(bs4Event.start), 
        EventSchEnd: Bs4Utils.toDateTime(bs4Event.end) , 
        currFormId: this.formId,
      }, this.bs4KartotekaId);
    },
  
    sortBs4EventViewArray: (bs4EventArray) => {
      return bs4EventArray.sort((a, b) => {        
        let comparison = compareAsc(a.startView, b.startView);
        if (comparison === 0) comparison = compareAsc(a.start, b.start);
        if (comparison === 0) comparison = compareAsc(b.endView, a.endView);
        if (comparison === 0) comparison = compareAsc(b.end, a.end);
        return comparison;
      })
    },    

    roundTo: function(date) {
      return roundToNearestMinutes(date, {nearestTo: this.nearestTo});
    },

    getBs4EventViewArray: function(resource) {
      const bs4EventViewArray = resource.bs4EventArray.filter(bs4Event => {
        if (compareAsc(this.end, bs4Event.start) < 0) return false;
        if (compareAsc(bs4Event.end, this.start) < 0) return false;
        this.updateBs4EventView(bs4Event);
        return true;
      });
      return this.sortBs4EventViewArray(bs4EventViewArray);
    },

    updateBs4EventView: function(bs4Event) {
      if (this.adjustmentToUnitWidth) switch (this.viewType) {

        case VIEW_TYPE_YEAR:
          bs4Event.startView = startOfMonth(bs4Event.start);
          bs4Event.endView = endOfMonth(bs4Event.end);
          break;

        case VIEW_TYPE_MONTH:
          // bs4Event.startView = startOfWeek(bs4Event.start);
          // bs4Event.endView = endOfWeek(bs4Event.end);
          bs4Event.startView = startOfDay(bs4Event.start);
          bs4Event.endView = endOfDay(bs4Event.end);
          break;
          
        case VIEW_TYPE_WEEK:
          bs4Event.startView = startOfDay(bs4Event.start);
          bs4Event.endView = endOfDay(bs4Event.end);
          break;
  
        case VIEW_TYPE_DAY:
        default:
          bs4Event.startView = startOfHour(bs4Event.start);
          bs4Event.endView = endOfHour(bs4Event.end);
          break;

      } else {
        
          bs4Event.startView = bs4Event.start;
          bs4Event.endView = bs4Event.end;
      }
    },

    moveDate: function(start, move, end) {      
      let d = null;
      if (this.adjustmentToUnitWidth) switch (this.viewType) {
        case VIEW_TYPE_YEAR:
          d = differenceInCalendarMonths(move, start);
          if (end) return [this.roundTo(addMonths(start, d)), this.roundTo(addMonths(end, d))]
          return [this.roundTo(addMonths(start, d)), d];

        case VIEW_TYPE_MONTH:
          d = differenceInCalendarDays(move, start);
          if (end) return [this.roundTo(addDays(start, d)), this.roundTo(addDays(end, d))]
          return [this.roundTo(addDays(start, d)), d];
          
        case VIEW_TYPE_WEEK:
          d = differenceInCalendarDays(move, start);
          if (end) return [this.roundTo(addDays(start, d)), this.roundTo(addDays(end, d))]
          return [this.roundTo(addDays(start, d)), d];
  
        case VIEW_TYPE_DAY:
        default:
          const hhh = differenceInHours(move, start) //??????????????????????????
          const h1 = parseInt(move.getTime() / 1000 / 60 / 60);
          const h2 = parseInt(start.getTime() / 1000 / 60 / 60);
          d = h1 - h2;
          if (end) return [this.roundTo(addHours(start, d)), this.roundTo(addHours(end, d))]
          return [this.roundTo(addHours(start, d)), d];
      } else {
        d = differenceInMilliseconds(move, start);
        if (end) return [this.roundTo(addMilliseconds(start, d)), this.roundTo(addMilliseconds(end, d))]
        return [this.roundTo(addMilliseconds(start, d)), d];
      }
    },

    updateScope: function() {
      let each = null;      
      this.headerArray = [];

      switch (this.viewType) {
        case VIEW_TYPE_YEAR:          
          this.start = startOfYear(this.date);
          this.end = endOfYear(this.date);

          each = eachYearOfInterval({start: this.start, end: this.end}).map(date => {            
            const start = startOfYear(date);
            const end = endOfYear(date);
            return {
              start: start,
              end: end,
              flex: 1,
              view: (
                <Typography>{format(start, 'yyyy')}</Typography>
              ),
            }
          });
          this.headerArray.push(each)
        
          each = eachMonthOfInterval({start: this.start, end: this.end}).map(date => {
            const start = startOfMonth(date);
            const end = endOfMonth(date);
            return {
              start: start,
              end: end,
              flex: getDaysInMonth(start),
              navigateTo: VIEW_TYPE_MONTH,
              view: (
                <Typography>{format(start, 'LLL')}</Typography>
              ),
            }
          })          
          this.headerArray.push(each)
          break;

        case VIEW_TYPE_MONTH:
          this.start = startOfMonth(this.date);
          this.start = startOfWeek(this.start);
          this.end = endOfMonth(this.date);
          this.end = endOfWeek(this.end);          

          each = eachMonthOfInterval({start: this.start, end: this.end}).map(date => {                
            const start = max([this.start, startOfMonth(date)]);
            const end = min([this.end, endOfMonth(date)]);
            // console.log('...Month.ddd...', Bs4Utils.toDate(start), Bs4Utils.toDate(end), differenceInCalendarDays(end, start))
            return {
              start: start,
              end: end,
              flex: differenceInCalendarDays(end, start) + 1,
              navigateTo: VIEW_TYPE_MONTH,
              view: (
                <Typography>{format(start, 'LLL yyyy')}</Typography>
              ),
            }
          });
          this.headerArray.push(each)

          each = eachWeekOfInterval({start: this.start, end: this.end}).map(date => {
            const start = startOfWeek(date);
            const end = endOfWeek(date);
            return {
              start: start,
              end: end,              
              flex: 1,
              navigateTo: VIEW_TYPE_WEEK,
              view: (
                <>
                  <Typography>{format(start, 'dd LLL yyyy')}</Typography>                  
                  <Typography variant='caption' sx={{opacity: 0.6}}>&nbsp;{'t.'+getWeek(start)}</Typography>
                </>
              ),
            }
          });
          this.headerArray.push(each)

          each = eachDayOfInterval({start: this.start, end: this.end}).map(date => {
            const start = startOfDay(date);
            const end = endOfDay(date);
            return {
              start: start,
              end: end,              
              flex: 1,
              navigateTo: VIEW_TYPE_DAY,
              view: (
                <>
                  <Typography variant='caption' sx={{opacity: 0.6}}>{format(start, 'EEEEE')}</Typography>
                  <Typography variant='body2'>&nbsp;{format(start, 'dd')}</Typography>
                </>
              ),
            }
          });  
          this.headerArray.push(each)
          break;
  
        case VIEW_TYPE_WEEK:
          this.start = startOfWeek(this.date);
          this.end = endOfWeek(this.date);

          each = eachWeekOfInterval({start: this.start, end: this.end}).map(date => {
            const start = startOfWeek(date);
            const end = endOfWeek(date);
            return {
              start: start,
              end: end,
              flex: 1,
              view: (
                <>                  
                  <Typography>{format(start, 'LLL yyyy')}</Typography>
                  <Typography variant='caption' sx={{opacity: 0.6}}>&nbsp;{'t.'+getWeek(start)}</Typography>
                </>
              ),
            }
          });
          this.headerArray.push(each);

          each = eachDayOfInterval({start: this.start, end: this.end}).map(date => {
            const start = startOfDay(date);
            const end = endOfDay(date);
            return {
              start: start,
              end: end,
              flex: 1,
              navigateTo: VIEW_TYPE_DAY,
              view: (
                <>
                  {/* <Typography variant='caption' sx={{opacity: 0.6}}>{format(start, 'EEEEE')}</Typography> */}
                  <Typography>&nbsp;{format(start, 'iii dd LLL yyyy')}</Typography>
                </>
              ),
            }
          });
          this.headerArray.push(each);
          break;
  
        case VIEW_TYPE_DAY:
        default:
          this.start = startOfDay(this.date);
          this.end = endOfDay(this.date);
          each = eachDayOfInterval({start: this.start, end: this.end}).map(date => {
            const start = startOfDay(date);
            const end = endOfDay(date);
            return {
              start: start,
              end: end,
              flex: 1,
              view: (
                <>                  
                  <Typography>&nbsp;{format(start, 'EEEE, dd LLLL yyyy')}</Typography>
                  <Typography variant='caption' sx={{opacity: 0.6}}>&nbsp;{'t.'+getWeek(start)}</Typography>
                </>
              ),
            }
          });
          this.headerArray.push(each);

          each = eachHourOfInterval({start: this.start, end: this.end}).map(date => {
            const start = startOfHour(date);
            const end = endOfHour(date);
            return {
              start: start,
              end: end,
              flex: 1,     
              view: (
                <Typography>{format(start, 'HH')}</Typography>
              ),
            }
          })
          this.headerArray.push(each);
          break;
      }      
    },

    updateRelative: function(n) {
      switch (this.viewType) {
        case VIEW_TYPE_YEAR:
          this.date = addYears(this.date, n);
          break;
  
        case VIEW_TYPE_MONTH:        
          this.date = addMonths(this.date, n);
          break;
  
        case VIEW_TYPE_WEEK:
          this.date = addWeeks(this.date, n);
          break;
  
        case VIEW_TYPE_DAY:
        default:
          this.date = addDays(this.date, n);
          break;
      }
    },

    updateRelativeParent: function(n) {
      switch (this.viewType) {
        // case VIEW_TYPE_YEAR:
        //   this.date = addYears(this.date, n);
        //   break;
  
        case VIEW_TYPE_MONTH:        
          this.date = addYears(this.date, n);
          break;
  
        case VIEW_TYPE_WEEK:
          this.date = addMonths(this.date, n);
          break;
  
        case VIEW_TYPE_DAY:
        default:
          this.date = addWeeks(this.date, n);
          break;
      }
    },

    updateRelativeYears: function(n) {
      this.date = addYears(this.date, n);      
    },
  }

  updateScope = () => {
    this.bs4Timeline.updateScope();    
    if (!this.bs4Timeline.startData || !this.bs4Timeline.endData || 
      compareAsc(this.bs4Timeline.startData, this.bs4Timeline.start) > 0 || 
      compareAsc(this.bs4Timeline.end, this.bs4Timeline.endData) > 0) {    
      this.loadData();
    } else {
      this?.setTimelineChangeTime(new Date());
    }    
  }

  setDisplayWait = (wait) => {}

  loadData = () => {
    const successCallback = (newResource, newBs4Events) => {
      console.log('...Bs4ReportTimeline...uccessCallback', this.bs4Timeline, newResource, newBs4Events)
      this.bs4Timeline.startData = this.bs4Timeline.start;
      this.bs4Timeline.endData = this.bs4Timeline.end;
      this.bs4Timeline.resourceArray = this.getResourceArray(newResource, newBs4Events);
      this.bs4Timeline.apiDict = {};      
      this.updateScope();
      this.setDisplayWait(false);
    };

    const failureCallback = (error) => {
      console.log('===Bs4ReportTimeline ERROR fetchMore', error);
      this.setDisplayWait(false);
    };
    
    this.setDisplayWait(true);
    if (this.fetchMore) this.fetchMore(this.bs4Timeline, successCallback, failureCallback)
  }

  getBs4Event = (bs4Event) => {        
    bs4Event.key = uuidv4();
    bs4Event.start = new Date(bs4Event.StartDate);
    bs4Event.end = new Date(bs4Event.EndDate);    
    bs4Event.duration = differenceInMilliseconds(bs4Event.end, bs4Event.start);
    
    bs4Event.chtime = Boolean(parseInt(bs4Event.chtime) === 1); // 1 - można przeciągać obiekt na tej samej osi= zmieniać termin/czas trwania obiektu na terminarzu (0-nie można)
    bs4Event.chaxis = Boolean(parseInt(bs4Event.chaxis) === 1); // 1 - można przeciągać obiekt między osiami (0-nie można)    
    bs4Event.chaxis0 = Boolean(this.bs4Timeline.columnMenuArray.length > 0);

    if (isNullOrNaN(bs4Event.layer)) bs4Event.layer = 0;
    bs4Event.progressP = parseFloat(bs4Event.progressP) || null;
    // bs4Event.progressP = Math.random() * 100;
    // if (bs4Event.id_previous) console.log('...???...previous', bs4Event)
    return bs4Event;
  }  

  getResourceArray = (newResourceArray, newBs4EventArray) => {
    const resourceArray = (Array.isArray(newResourceArray) ? newResourceArray : []).sort((a, b) => a.Ordered - b.Ordered);
    const bs4EventArray = (Array.isArray(newBs4EventArray) ? newBs4EventArray : []).map(bs4Event => this.getBs4Event(bs4Event));
    return resourceArray.map(resource => {
      resource.key = uuidv4();
      resource.bs4EventArray = bs4EventArray.filter(bs4Event => bs4Event.ResourceId === resource.Id);
      resource.bs4EventArray.forEach(bs4Event => {
        bs4Event.parentKey = resource.key;
      });
      return resource;
    });
  }

  ViewFooter = (props) => {
    const report = this;

    const [footerButtonsSCHEDULER, footerButtonsMODIFIER] = React.useMemo(() => {
      const footerButtonsSCHEDULER = footerButtons.filter(view => isSelected(props.viewButtons ,view, TYPE_SCHEDULER));
      const footerButtonsMODIFIER = footerButtons.filter(view => isSelected(props.viewButtons ,view, TYPE_MODIFIER));
      if (!footerButtonsSCHEDULER.find(view => view.viewType === this.bs4Timeline.viewType)) {
        this.bs4Timeline.viewType = footerButtonsSCHEDULER[0]?.viewType || VIEW_TYPE_YEAR;
      }
      return [footerButtonsSCHEDULER, footerButtonsMODIFIER]      
    }, [props.viewButtons])

    const [visibility, setVisibility] = React.useState(true);
    
    const [modifiers, setModifiers] = React.useState([]);          

    const handleViewType = (e, viewType) => {
      this.bs4Timeline.viewType = viewType;
      this.updateScope();
    }

    const handleSettings = React.useCallback((e, modifiers) => {
      setModifiers(modifiers);
      this.bs4Timeline.layer0 = modifiers.includes(VIEW_TYPE_MODIFIER_LAYER0);
      this.bs4Timeline.layer1 = modifiers.includes(VIEW_TYPE_MODIFIER_LAYER1);
      // Tekst na button ma przeciwne znaczenie.
      this.bs4Timeline.adjustmentToUnitWidth = !modifiers.includes(VIEW_TYPE_MODIFIER_ADJUSTMENT_TO_UNIT_WIDTH);
      this.updateScope();        
    }, [setModifiers]);
  
    const handleNavigationPreviousParentPeriod = (e) => {
      this.bs4Timeline.updateRelativeParent(-1);      
      this.updateScope();
    }

    const handleNavigationPreviousPeriod = (e) => {
      this.bs4Timeline.updateRelative(-1);
      this.updateScope();
    }

    const handleNavigationNextPeriod = (e) => {
      this.bs4Timeline.updateRelative(1);
      this.updateScope();
    }

    const handleNavigationNextParentPeriod = (e) => {
      this.bs4Timeline.updateRelativeParent(1);      
      this.updateScope();
    }

    const handleDateChange = (newValue) => {      
      this.bs4Timeline.date = newValue;
      this.updateScope();
    }

    React.useEffect(() => {
      handleSettings(null, props.modifiers);
    }, [handleSettings, props.modifiers])

    React.useEffect(() => {
      const bs4kartoteka = Bs4Kartoteka.get(this.bs4KartotekaId);
      if (bs4kartoteka) bs4kartoteka.eventEmit.on(Bs4Kartoteka.CHANGE_VISIBILITY, setVisibility);  
      return () => {
        if (bs4kartoteka) bs4kartoteka.eventEmit.off(Bs4Kartoteka.CHANGE_VISIBILITY, setVisibility);  
      }
    }, [this.bs4KartotekaId])

    return (
      <Bs4ViewFooter
        footerButtons={footerButtonsSCHEDULER}        
        viewType={report.bs4Timeline.viewType}
        exact={!report.bs4Timeline.adjustmentToUnitWidth}
        footerButtonsModifier={footerButtonsMODIFIER}
        modifiers={modifiers}
        onChangeViewType={handleViewType}
        onChangeSettings={handleSettings}

        sx={props.sx}
        slotProps={{
          navigation: {
            date: report.bs4Timeline.date || new Date(),
            moveYear: this.bs4Timeline.viewType !== VIEW_TYPE_YEAR,
            visibility: visibility,
            previousYear: handleNavigationPreviousParentPeriod,
            previousPeriod: handleNavigationPreviousPeriod,
            nextPeriod: handleNavigationNextPeriod,
            nextYear: handleNavigationNextParentPeriod,     
            onDataChange: handleDateChange,
          },
          reportIcon: {
            sx: {flex: 0},
            onShow: props.onShow,
            onRemember: props.onRemember,
            onReset: props.onReset,
          }
        }}
      />
    )
  }

  ViewOption = React.memo((props) => {
    const report = this;   
    const theme = useTheme();
    const [menuChangeTime, setMenuChangeTime] = React.useState(new Date());
    const [bs4EventArray, setBs4EventArray] = React.useState([]);    

    const updateAdd = React.useCallback((bs4Event) => {
      arrayAddElement(props.menuItem?.bs4EventArray, bs4Event);
      setMenuChangeTime(new Date());
    }, [props.menuItem?.bs4EventArray])

    const updateRemove = React.useCallback((bs4Event) => {
      const e = arrayRemoveElement(props.menuItem?.bs4EventArray, bs4Event, '...ViewOption...Remove...!!!!!..');
      if (!e) {
        console.log('...ViewOption...Error...updateRemove.null')
      }
      setMenuChangeTime(new Date());
      return e;
    }, [props.menuItem?.bs4EventArray])

    const updateEnd = React.useCallback((bs4Event) => {
      props.onMenuClick(props.menuItem.menuItem, bs4Event);
    }, [props.menuItem?.bs4EventArray]);

    const setBs4ActiveMove = React.useCallback((active, over, propsEnd) => {      
      if (! active?.props?.bs4Event) return;
      const bs4Event = active.props.bs4Event;
      
      if (!over) {
        if (propsEnd) {
          this.bs4Timeline.apiDict[props.menuItem.key].updateEnd(bs4Event);
        }
        return;
      }

      // console.log('...???...setBs4ActiveMove.O.', bs4Event.chtime, bs4Event.chaxis, bs4Event.parentKey !== props.menuItem.key, props.menuItem.key);
      
      if (bs4Event.parentKey !== props.menuItem.key) {
        this.bs4Timeline.apiDict[bs4Event.parentKey].updateRemove(bs4Event);
        this.bs4Timeline.apiDict[props.menuItem.key].updateAdd(bs4Event);
        bs4Event.parentKey = props.menuItem.key;
      }  
      
      if (navigator.vibrate) navigator.vibrate(1);      
    }, [this.bs4Timeline.apiDict, props.menuItem.key]);
    
    const droppableRef = React.useMemo(() => {return {};}, []);
    const {isOver, active, setNodeRef, node} = useDroppable({
      id: DROPPABLE+'_option_menu_'+props.menuItem.index,
      data: {
        droppableRef,
        setBs4ActiveMove, 
      }
    });

    React.useEffect(() => {
      this.bs4Timeline.apiDict[props.menuItem.key] = {
        updateAdd,
        updateRemove,
        updateEnd,  
      }
    }, [this.bs4Timeline.apiDict, props.menuItem.key, updateAdd, updateRemove, updateEnd])
    
    const boxSx = React.useMemo(() => {
      return {
        backgroundColor: lighten(theme.palette.primary.main, 0.8),
        color: theme.palette.text.primary,
        ...getBoxSx(props.uxBodyOption, theme),
        ...getBoxSx(props.menuItem?.style, theme),
        flex: 1,
      }
    }, [theme, props.uxBodyOption, props.menuItem?.style]);

    return (
      <Box 
        ref={setNodeRef} 
        sx={boxSx}
      >
        <Box>{props.menuItem.title}</Box>
        {props.menuItem?.bs4EventArray?.map(bs4Event => {
          return (
            <ViewBs4EventDraggable 
              key={bs4Event.key} 
              bs4Event={bs4Event} 
              uxBodyEvent={props.uxBodyEvent}
              onRowClick={props.onRowClick}
              bs4Timeline={report.bs4Timeline}              
            />        
          )
        })}        
      </Box>
    )
  });

  resetColumnsMenu = () => {
    console.log('=== Error === resetColumnsMenu not implemented');
  }

  ViewOptions = (props) => {
    const report = this;    
    const [columnsMenu, setColumnsMenu] = React.useState([]);
    // console.log('...ViewOptions...', columnsMenu, props)

    React.useEffect(() => {
      this.resetColumnsMenu = () => {
        this.bs4Timeline.columnMenuArray = (props.columnsMenu || []).map(menuItem => {
          menuItem.key = uuidv4();
          menuItem.bs4EventArray = [];
          return menuItem;
        })
        setColumnsMenu();
      }

      this.resetColumnsMenu();
    }, [props.columnsMenu, setColumnsMenu])

    return (
      <Box width='100%' display='flex' flexDirection='row' flexWrap='wrap' gap={2} p={props.columnsMenu?.length > 0 ? 2 : 0}>
        {report.bs4Timeline.columnMenuArray?.map((menuItem) => {
          if (!Array.isArray(menuItem.bs4EventArray)) menuItem.bs4EventArray = [];
          return (
            <report.ViewOption
              key={menuItem.key}
              menuItem={menuItem}
              uxBodyOption={props.uxBodyOption}
              uxBodyEvent={props.uxBodyEvent}
              onMenuClick={props.onMenuClick}
            />
          )
        })}
      </Box>
    )
  }

  orderBs4EventArray = (bs4EventArray) => {
    const lines = [];
    
    for (let bs4Event of bs4EventArray) {
      let pushed = false;

      for (let line of lines) {
        if (compareAsc(line.bs4Event.endView, bs4Event.startView) < 0) {
          bs4Event.line = line.bs4Event.line;
          line.bs4Event = bs4Event;
          pushed = true;
          break;
        }
      }
      
      if (!pushed) {
        bs4Event.line = lines.length;
        lines.push({bs4Event: bs4Event});
      }
    };

    return lines.length;
  }

  scrollMargin = 5;

  ViewLeftColumnWidthResize = (props) => {
    const report = this;
    const smallScreen = React.useContext(SmallScreenContext);
    const cursor = 'col-resize';    
    const [width, setWidth] = React.useState(parseInt(this.initialValues.leftColumnWidth) || 150);
    const [delta, setDelta] = React.useState(0);
    const [startPosition, setStartPosition] = React.useState(null);
    const ref = React.useRef({handleTouchStartTimeout: null});    
    const refBox0 = React.useRef(null);    
    const refBox1 = React.useRef(null);    

    const resetWidth = React.useCallback(() => {
      // console.log(new Error('...^^^...resetWidth.x.x.x.x.x'));
      if (smallScreen) {
        setDelta(0);
        setStartPosition(null);
        return  
      }
      const rect0 = refBox0.current.getBoundingClientRect();
      const rect1 = refBox1.current.getBoundingClientRect();
      if (rect0 && rect1) setWidth(rect0.width - rect1.width);
      setDelta(0);
      setStartPosition(null);
      props.setCursor(null);
    }, [smallScreen, refBox0.current, refBox1.current, setWidth, setDelta, setStartPosition, props.setCursor]);

    const handlePointerDown = React.useCallback((event) => {      
      if (event.pointerType === 'touch') return;
      // console.log('...^^^...PointerDown');
      resetWidth();
      setStartPosition({x: event.clientX, y: event.clientX});
      props.setCursor(cursor);
    }, [setStartPosition]);

    const handlePointerMove = React.useCallback((event) => {      
      if (event.pointerType === 'touch') return;      
      if (!startPosition) return;
      setDelta(event.clientX - startPosition.x);
    }, [startPosition, setDelta]);

    const handlePointerUp = React.useCallback((event) => {      
      if (event.pointerType === 'touch') return;
      if (!startPosition) return;
      setStartPosition(null);
      resetWidth();      
    }, [startPosition, setStartPosition, resetWidth]);

    const handleTouchStart = React.useCallback((event) => {
      clearTimeout(ref.current.handleTouchStartTimeout);      
      ref.current.handleTouchStartTimeout = setTimeout(() => {
        const touch = event.touches[0];
        resetWidth();
        setStartPosition({x: touch.clientX, y: touch.clientX});
      }, 200);      
    }, [ref.current, resetWidth, setStartPosition]);

    const handleTouchMove = React.useCallback((event) => {      
      clearTimeout(ref.current.handleTouchStartTimeout);
      if (!startPosition) return;
      const touch = event.touches[0];
      setDelta(touch.clientX - startPosition.x);
    }, [ref.current, startPosition, setDelta]);
    
    const handleTouchEnd  = React.useCallback((event) => {
      clearTimeout(ref.current.handleTouchStartTimeout);
      if (!startPosition) return;
      setStartPosition(null);
      resetWidth();
    }, [ref.current, startPosition, setStartPosition, resetWidth]);    

    React.useEffect(() => {       
      window.addEventListener('pointermove', handlePointerMove);
      window.addEventListener('pointerup', handlePointerUp);

      window.addEventListener('touchmove', handleTouchMove);
      window.addEventListener('touchend', handleTouchEnd);

      return () => {
        window.removeEventListener('pointermove', handlePointerMove);
        window.removeEventListener('pointerup', handlePointerUp);

        window.removeEventListener('touchmove', handleTouchMove);
        window.removeEventListener('touchend', handleTouchEnd);
      }
    }, [handlePointerMove, handlePointerUp, handleTouchMove, handleTouchEnd]);

    return (
      <Box 
        ref={refBox0}
        gridColumn='1 / 3' 
        gridRow='1 / 3' 
        display='grid' 
        gridTemplateColumns='subgrid' 
      >
        <Box 
          gridColumn={1} 
          width={smallScreen ? 0 : width + delta} 
        />
        <Box
          ref={refBox1}
          sx={{
            gridColumn: 2, 
            zIndex: 200,
            cursor: cursor,
            backgroundColor: Boolean(startPosition) ? '#000000' : report.borderColor,
          }}
          onPointerDown={handlePointerDown}
          onTouchStart={handleTouchStart}
        />
      </Box>
    )   
  }

  ViewHeaderLine  = (props) => {
    const report = this;

    const flexSum = React.useMemo(() => {
      let flexSum = 0;
      props.line.forEach(header => flexSum += header.flex);
      return flexSum;
    }, [props.line])    
    
    const handleNavigateTo = (header) => {
      this.bs4Timeline.date = header.start;
      this.bs4Timeline.viewType = header.navigateTo;
      this.updateScope();
    }            

    return (
      <Stack direction="row" justifyContent="flex-start" alignItems="flex-start" spacing={0} sx={{flex: 1, width: '100%'}}>
        {props.line.map((header, index) => {
          return (
            <HeaderButton 
              key={index}
              onClick={event => handleNavigateTo(header)} 
              disabled={!header?.navigateTo} 
              component='div' 
              sx={{width: ((header.flex / flexSum) * 100)+'%', ...report.bs4Timeline.borderEnd, height: '100%'}}
            >              
              <Stack component='span' direction="row" justifyContent="center" alignItems="baseline" spacing={0} flexWrap='wrap'>
                {header.view}
              </Stack>
            </HeaderButton>      
          )
        })}
      </Stack>      
    )
  }

  ViewHeaderLineBorder  = (props) => {
    const report = this;

    const flexSum = React.useMemo(() => {
      let flexSum = 0;      
      props?.line?.forEach(header => flexSum += header.flex);
      return flexSum;
    }, [props.line])    

    return (
      <Stack direction="row" justifyContent="flex-start" alignItems="flex-start" spacing={0} sx={{height: '100%', width: '100%'}}>
        {props.line?.map((header, index) => {
          return (
            <Box key={index} sx={{width: ((header.flex / flexSum) * 100)+'%', ...report.bs4Timeline.borderEnd, height: '100%'}}/>
          )
        })}
      </Stack>      
    )
  }

  ViewHeader = (props) => {
    const report = this;

    const smallScreen = React.useContext(SmallScreenContext);
    // const lastLine = report.bs4Timeline.headerArray.at(-1);
    const lastLine = report.bs4Timeline.headerArray[report.bs4Timeline.headerArray.length - 1];
    const lastLineFlexSum = React.useMemo(() => {
      let flexSum = 0;
      lastLine?.forEach(header => flexSum += header.flex);
      return flexSum;
    }, [lastLine]) 
    
    const isNavigateUp = this.bs4Timeline.viewType !== VIEW_TYPE_YEAR;

    const handleNavigateUp = (each) => {
      if (this.bs4Timeline.viewType === VIEW_TYPE_MONTH) this.bs4Timeline.viewType = VIEW_TYPE_YEAR;
      if (this.bs4Timeline.viewType === VIEW_TYPE_WEEK) this.bs4Timeline.viewType = VIEW_TYPE_MONTH;
      if (this.bs4Timeline.viewType === VIEW_TYPE_DAY) this.bs4Timeline.viewType = VIEW_TYPE_WEEK;            
      this.updateScope();
    }    

    return (
      <Box
        sx={{
          display: 'grid', 
          gridColumn: '1 / 4', 
          gridRow: '1 / 3',
          gridTemplateColumns: 'subgrid', 
          gridTemplateRows: 'subgrid', 
          overflow: 'hidden',
          ...report.bs4Timeline.borderStart
        }}
      >
        <HeaderButton
          onClick={handleNavigateUp}
          disabled={!isNavigateUp}
          component='div'
          sx={{            
            gridColumn: 1, 
            gridRow: 1,
            display: 'flex', 
            alignItems: 'center', 
            overflow: 'hidden',
            ...report.bs4Timeline.borderEnd, 
            p: 0,
          }}
        >
          {smallScreen ? null : 
            <Typography 
              variant='h6' 
              component='div'           
            >
              {report.initialValues.bs4axisName || ''}
            </Typography>
          }
        </HeaderButton> 
        <Stack direction="column" justifyContent="flex-start" alignItems="flex-start" spacing={0} sx={{gridColumn: 3, gridRow: 1, height: '100%'}}>
          {report.bs4Timeline.headerArray.map((line, index) =>
            <report.ViewHeaderLine key={index} line={line}/>
          )}
          {smallScreen ?
            <Typography               
              variant='body2'
              sx={{
                position:'absolute',
                top: 0,
                left: 0,
                opacity: 0.5,
                pointerEvents: 'none',
                // zIndex: 2000,
                backgroundColor: '#ffffff66',
                boxShadow: '0 0 4px 4px #ffffff66',
              }}         
            >
              {report.initialValues.bs4axisName || ''}
            </Typography>
            : null
          }
        </Stack>
        <Stack direction="row" justifyContent="flex-start" alignItems="flex-start" spacing={0} sx={{gridColumn: 3, gridRow: 2, height: '100%'}}>
          {lastLine?.map((header, index) => 
            <Box key={index} sx={{width: ((header.flex / lastLineFlexSum) * 100)+'%', ...report.bs4Timeline.borderEnd, height: '100%'}}/>
          )}
        </Stack>           
        <report.ViewClockHand timelineChangeTime={props.timelineChangeTime}/>        
      </Box>
    )
  }  

  ViewClockHand = React.memo((props) => {
    const report = this;
    const theme = useTheme();
    const [currentTime, setCurrentTime] = React.useState(new Date());
    
    React.useEffect(() => {
      let interval = 60;
      switch (this.bs4Timeline.viewType) {
        case VIEW_TYPE_YEAR:
          interval = 60 * 60 * 24;
          break;
        case VIEW_TYPE_MONTH:
          interval = 60 * 60;
          break;
        case  VIEW_TYPE_WEEK:
          interval = 60 * 60;
          break;
        case  VIEW_TYPE_DAY:
          interval = 60;
          break;
      }
      const intervalCurrentTime = setInterval(() => {
        setCurrentTime(new Date());
      }, interval * 1000);

      return () => clearInterval(intervalCurrentTime);
    }, [setCurrentTime, props.timelineChangeTime, this.bs4Timeline.viewType])

    const percentCurrentTime = React.useMemo(() => {
      const timelineStartTime = this.bs4Timeline?.start?.getTime() || 0;
      const timelineEndTime = this.bs4Timeline?.end?.getTime() || 0;
      return ((1.0 * (currentTime.getTime() - timelineStartTime)) / (timelineEndTime - timelineStartTime)) * 100.0;
    }, [currentTime, props.timelineChangeTime, this.bs4Timeline?.start, this.bs4Timeline?.end]);
    
    if (percentCurrentTime <= 0 || percentCurrentTime >= 100) return null;
    const ccc= this.borderToday
    return (
      <Box         
        sx={{
          gridColumn: 3,
          gridRowStart: 1,
          gridRowEnd: 3, 
          position: 'relative',
          left: percentCurrentTime+'%', 
          width: '0px',
          userSelect: 'none',        
          pointerEvents: 'none',
          borderLeft: '3px dashed #ff000022',
          zIndex: 200,
        }}
      />
      )
  });
  
  ViewResourceLayer = React.memo((props) => {
    const report = this;       
    const [nodeParent, setNodeParent] = React.useState(null);
    const refBox = React.useRef(null);

    const scrollState = React.useContext(this.ScrollContext);
    const [lineFrom, lineTo] = React.useMemo(() => {
      const rectB = refBox.current?.getBoundingClientRect();
      const rectS = scrollState?.rect;
      if (!rectB || ! rectS) return [null, null];
      const top = rectS.top - rectB.top;
      const bottom = rectB.bottom - rectS.top - rectS.height;

      const topL = top > 0 ? Math.floor(top / this.bs4Timeline.bs4EventHeight) : 0;
      const bottomL = bottom > 0 ? Math.floor(bottom / this.bs4Timeline.bs4EventHeight) : 0;      

      return [topL - this.scrollMargin, props.lines - bottomL + this.scrollMargin];
    }, [scrollState, refBox.current]);

    React.useEffect(() => {
      setNodeParent(refBox.current);
    }, [refBox.current, setNodeParent])

    return (
      <Box        
        ref={refBox} 
        sx={{position:'absolute', top:0, right:0, bottom: 0, left: 0}} 
      >
        {nodeParent ? props.eventViews.map(bs4Event => {
          if (!this.initialValues.bs4FormField) {            
            if ((lineFrom === null || lineTo === null) && !bs4Event?.move?.active) return null;
            if ((bs4Event.line < lineFrom || bs4Event.line > lineTo) && !bs4Event?.move?.active) return null;
          }
          return <ViewBs4EventDraggable 
            key={bs4Event.key}
            timelineChangeTime={props.timelineChangeTime}
            resourceChangeTime={props.resourceChangeTime}
            activeChangeTime={props.activeChangeTime}
            bs4Event={bs4Event} 
            nodeParent={nodeParent}
            line={bs4Event.line}
            uxBodyEvent={props.uxBodyEvent}
            onRowClick={props.onRowClick}
            bs4Timeline={report.bs4Timeline}
            scrollBy={props.scrollBy}
          />
        }) : null}
      </Box>
    )
  });

  ViewResource = React.memo((props) => {
    const report = this;    
    const smallScreen = React.useContext(SmallScreenContext);
    const [selectResourse, setSelectResourse] = React.useState(false);
    const [resourceChangeTime, setResourceChangeTime] = React.useState(new Date());
    const [activeChangeTime, setActiveChangeTime] = React.useState(new Date());
    const [bs4EventViewArrayL0, bs4EventViewArrayL1, lines] = React.useMemo(() => {
      const bs4EventViewArray = this.bs4Timeline.getBs4EventViewArray(props.resource);
      const bs4EventViewArrayL0 = [];
      const bs4EventViewArrayL1 = [];
      bs4EventViewArray.forEach(bs4Event => {
        if (bs4Event?.move?.active) return;
        else if (this.bs4Timeline.layer0 && bs4Event.layer === 0) bs4EventViewArrayL0.push(bs4Event);
        else if (this.bs4Timeline.layer1 && bs4Event.layer === 1) bs4EventViewArrayL1.push(bs4Event);
        else {
          console.log('...ERROR ViewResource, layer 0 ?, layer 1 ?, layer a')
        };
      })
      const l0 = this.orderBs4EventArray(bs4EventViewArrayL0);
      const l1 = this.orderBs4EventArray(bs4EventViewArrayL1);
      return [bs4EventViewArrayL0, bs4EventViewArrayL1, Math.max(1, l0, l1)];
    }, [props.timelineChangeTime, resourceChangeTime, props.resource]);

    const [activeEvent, setActiveEvent] = React.useState(null);
    const refTouchStart = React.useRef({timeOut: null, }); 

    const setBs4ActiveMove = React.useCallback((active, over, propsEnd) => {      
      if (! active?.props?.bs4Event) return;
      const bs4Event = active.props.bs4Event;      
      
      if (!over) {
        if (propsEnd) {          
          propsEnd.bs4EventDrop(bs4Event);
        }
        return;
      }
      
      if (bs4Event.parentKey !== props.resource.key) {
        if (bs4Event.chaxis) {
          this.bs4Timeline.apiDict[bs4Event.parentKey].updateRemove(bs4Event);
          this.bs4Timeline.apiDict[props.resource.key].updateAdd(bs4Event);
          bs4Event.parentKey = props.resource.key;
        } else {
          this.bs4Timeline.apiDict[bs4Event.parentKey].updateRemove(bs4Event);
          this.bs4Timeline.apiDict[bs4Event.move.parentKey].updateAdd(bs4Event);
          bs4Event.parentKey = bs4Event.move.parentKey;  
        }
      }

      if (bs4Event.chtime) {
        const rect = over.rect;
        const pointerCoordinates = over.data.current.droppableRef.pointerCoordinates;
        const moveDate = addMilliseconds(this.bs4Timeline.start, differenceInMilliseconds(this.bs4Timeline.end, this.bs4Timeline.start) / rect.width * (pointerCoordinates.x - rect.left));
        const differenceInMillisecondsMove = differenceInMilliseconds(moveDate, bs4Event.move.moveDate);
        const start = this.bs4Timeline.roundTo(addMilliseconds(bs4Event.move.start, differenceInMillisecondsMove));
        if (compareAsc(start, bs4Event.start) !== 0) {
          bs4Event.start = start;
          bs4Event.end = addMilliseconds(bs4Event.start, bs4Event.duration);
          this.bs4Timeline.apiDict[bs4Event.parentKey].setActiveChangeTime(new Date());
          // At start only !!!.
          if (bs4Event.parentKey === props.resource.key && !activeEvent) {
            this.bs4Timeline.apiDict[bs4Event.parentKey].updateRemove(bs4Event);
            this.bs4Timeline.apiDict[bs4Event.parentKey].updateAdd(bs4Event);
          }
        }
      }
      
      if (navigator.vibrate) navigator.vibrate(1);      
    }, [this.bs4Timeline.apiDict, this.bs4Timeline.start, this.bs4Timeline.end, props.resource.key, setActiveChangeTime, activeEvent]);

    const droppableRef = React.useMemo(() => {return {};}, []);

    const {isOver, active, setNodeRef, node} = useDroppable({
      id: DROPPABLE+'_'+props.resource.key,
      data: {
        droppableRef,
        setBs4ActiveMove,
      }
    });

    React.useEffect(() => {
      setSelectResourse(isOver);
    }, [isOver, setSelectResourse]);

    const updateAdd = React.useCallback((bs4Event) => {
      if (bs4Event.move?.active) {
        setActiveEvent(bs4Event);
        setActiveChangeTime(new Date());
      } else {
        if (!arrayAddElement(props.resource?.bs4EventArray, bs4Event)) {
          console.log('...ViewResource...Error...updateAdd.null', props.resource?.bs4EventArray, bs4Event);
          return;
        }
        setResourceChangeTime(new Date());
      }      
    }, [setActiveEvent, setActiveChangeTime, setResourceChangeTime, props.resource]);

    const updateRemove = React.useCallback((bs4Event) => {      
      const e = arrayRemoveElement(props.resource?.bs4EventArray, bs4Event, '...ViewResource...Remove...!!!!!..');
      if (e) {
        setResourceChangeTime(new Date());
      }
      if (activeEvent === bs4Event) {
        setActiveEvent(null);
        setActiveChangeTime(new Date());
      }
    }, [activeEvent, setActiveEvent, setActiveChangeTime, setResourceChangeTime, props.resource]);    

    const updateEnd = React.useCallback((bs4Event) => {
      this.bs4Timeline.bs4EventDrop(bs4Event, props.resource);
    }, [props.resource]);

    React.useEffect(() => {
      this.bs4Timeline.apiDict[props.resource.key] = {
        updateAdd,
        updateRemove,
        updateEnd,
        setResourceChangeTime,
        setActiveChangeTime,
      }
    }, [this.bs4Timeline.apiDict, props.resource?.key, updateAdd, updateRemove, updateEnd, setResourceChangeTime, setActiveChangeTime]);

    // const img = Bs4MainDispatch.getUrlPath('bs4_Backend/bs4_image/bs_avatar.png');    
    // console.log('...ViewResource...', Bs4Utils.toDateTime(props.timelineChangeTime), props.resource.SizeX, props.resource.SizeY, props.resource)    
    
    const addNewEvent = React.useCallback((event) => {
      if (parseInt(this.initialValues.allowaddevent) !== 1) return;
      const rect = node.current?.getBoundingClientRect();
      if (!rect) return;

      const timeToWidthRatio = differenceInMilliseconds(this.bs4Timeline.end, this.bs4Timeline.start) / rect.width;
      const date = addMilliseconds(new Date(this.bs4Timeline.start), timeToWidthRatio * (event.clientX - rect.x));
      const newEvent = this.getBs4Event({        
        parentKey: props.resource.key,
        StartDate: Bs4Utils.toDateTime(this.bs4Timeline.roundTo(date)),
        EndDate: Bs4Utils.toDateTime(this.bs4Timeline.roundTo(date)),
        xx555: null,
        Name: 'New event',
        bs4fill2: null,
        id: uuidv4(),
        ResourceId: props.resource.Id,
        chaxis: 1,
        chtime: 1,
        line: 0,
        move: {
          active: true,
          new: true,
          cursor: 'e',
        },
      });                        
      
      setActiveEvent(newEvent);
    }, [props.resource, node.current, setActiveEvent]);
    
    const updateNewEvent = React.useCallback((event, bs4Event) => {
      const rect = node.current?.getBoundingClientRect();
      if (!rect) return;
      const timeToWidthRatio = differenceInMilliseconds(this.bs4Timeline.end, this.bs4Timeline.start) / rect.width;
      const date = addMilliseconds(this.bs4Timeline.start, timeToWidthRatio * (event.clientX - rect.x));
      const [movedDate, d] = this.bs4Timeline.moveDate(bs4Event.end, date);
      if (compareDesc(bs4Event.start, movedDate) >= 0 && compareAsc(bs4Event.end, movedDate) !== 0) {
        bs4Event.end = movedDate;
        setActiveChangeTime(new Date());
        return;
      }
    }, [setActiveChangeTime]);

    const removeNewEvent = React.useCallback(() => {
      if (!activeEvent) return;
      // ?? this.bs4Timeline.apiDict[props.resource.key].updateRemove(activeEvent);
      setActiveEvent(null);
      setActiveChangeTime(new Date());
    }, [activeEvent, setActiveEvent]);

    const scrollBy = React.useCallback((pageX, pageY) => {
      // if (!activeEvent?.move?.new) return;

      const rect = props.refScroll.current.getBoundingClientRect();

      if (!rect) return;
      
      const threshold = 50;
      const left = pageX - rect.left;
      const right = rect.right - pageX;
      if (left < threshold) {
        // refScroll.current.scrollBy(0, -(threshold - top / 2))      
        props.refScroll.current.scrollBy({
          top: 0,
          left: -(threshold - left / 2),
          behavior: "smooth",
        });
      }

      if (right < threshold) {
        // refScroll.current.scrollBy(0, threshold - bottom / 2)      
        props.refScroll.current.scrollBy({
          top: 0,
          left: threshold - right / 2,
          behavior: "smooth",
        });
      }
      // console.log('...???...scrollBy', top, bottom);
    }, [props.refScroll.current, activeEvent]);
    
    const handlePointerDown = React.useCallback(event => {
      if (event.pointerType === 'touch') return;
      console.log('...???...TimeLine.ViewResourceLayer.PointerDown', event);
      if (activeEvent) return;      
      addNewEvent(event);
    }, [activeEvent, addNewEvent]);

    const handlePointerMove = React.useCallback(event => {
      if (event.pointerType === 'touch') return;
      // console.log('...???...Pointer.Move...', activeEvent, event);
      if (!activeEvent) return;
      updateNewEvent(event, activeEvent);
      scrollBy(event.pageX, event.pageY);
    }, [activeEvent, updateNewEvent]);

    const handlePointerUp = React.useCallback(event => {
      if (event.pointerType === 'touch') return;      
      // console.log('...???...Pointer.UP...', newEvent);
      if (!activeEvent) return;
      this.bs4Timeline.bs4Select(activeEvent); 
      removeNewEvent();
    }, [activeEvent, removeNewEvent]);

    const handlePointerCancel = React.useCallback(event => {
      if (event.pointerType === 'touch') return;      
      // console.log('...???...Pointer.Cancel...', newEvent);
      if (!activeEvent) return;
      removeNewEvent();
    }, [activeEvent, removeNewEvent]);

    const handleTouchStart = React.useCallback((event) => {
      // console.log('...???...TouchStart...', event);
      if (activeEvent) return;
      clearTimeout(refTouchStart.current.timeOut);
      refTouchStart.current.timeOut = setTimeout(() => {
        addNewEvent(event.touches[0]);  
      }, 500);      
    }, [activeEvent, addNewEvent]);

    const handleTouchMove = React.useCallback((event) => {
      // console.log('...???...TouchMove...', event);
      clearTimeout(refTouchStart.current.timeOut);
      if (!activeEvent) return;
      const touch = event.touches[0];
      updateNewEvent(touch, activeEvent);
      scrollBy(touch.pageX, touch.pageY);
    }, [activeEvent, ]);
    
    const handleTouchEnd  = React.useCallback((event) => {
      // console.log('...???...TouchEnd...', newEvent);      
      clearTimeout(refTouchStart.current.timeOut);
      if (!activeEvent) return;
      this.bs4Timeline.bs4Select(activeEvent);
      removeNewEvent();
    }, [activeEvent, removeNewEvent]);

    const handleTouchCancel = React.useCallback((event) => {
      // console.log('...???...TouchCancel...', newEvent);
      clearTimeout(refTouchStart.current.timeOut);
      if (!activeEvent) return;
      removeNewEvent();
    }, [activeEvent, removeNewEvent]);

    const handleKeyDown  = React.useCallback((event) => {
      // console.log('...KeyDown...', event);
      clearTimeout(refTouchStart.current.timeOut);
      if (event.code !== 'Escape') return;
      if (!activeEvent) return;
      removeNewEvent();
    }, [activeEvent, removeNewEvent]);

    const avatarSize = 32;

    // console.log('...???...ViewResource...', activeEvent, activeChangeTime?.getTime());

    return (      
      <Box
        sx={{
          position: 'relative',
          gridColumn: '1 / span 4', 
          display: 'grid', 
          gridTemplateColumns: 'subgrid', 
          minHeight: report.bs4Timeline.bs4EventHeight * Math.max(1, lines),
          backgroundColor: (selectResourse ? report.selectColor : 'transparent'),
          ...report.bs4Timeline.borderEnd,
          overflow: 'hidden',
        }}
      >        
        <Stack 
          direction={'row'}
          spacing={1} 
          sx={{
            width: '100%',
            gridColumn: '1', 
            justifyContent: "flex-start",
            alignItems: "flex-start", 
            padding: '5px',
            overflow: 'hidden',
          }}
        >
          <Bs4ViewAvatar
            img={props.resource.Icon} //  || 'bs4_core.png'
            fileId={props.resource.fileId}
            initials={props.resource.initials} 
            label={props.resource.Name} 
            circleColor={props.resource.circleColor} 
            size={avatarSize}            
          />
          {smallScreen ? null : 
            <Typography sx={{p: 0.5}}>
              {props.resource.Name} 
              {/* {props.resource.key} */}
            </Typography>
          }
        </Stack>
        <Box 
          ref={setNodeRef}
          sx={{
            position: 'relative',
            gridColumn: 3, 
            display: 'flex', 
            flex: 1, 
            position: 'relative'
          }}
          onPointerDown={handlePointerDown}
          onPointerMove={handlePointerMove}
          onPointerUp={handlePointerUp}
          onPointerCancel={handlePointerCancel}
  
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={handleTouchEnd}
          onTouchCancel={handleTouchCancel}

          onKeyDown={handleKeyDown}
        >
          {report.bs4Timeline.layer1 ? 
            <report.ViewResourceLayer
              resource={props.resource}
              timelineChangeTime={props.timelineChangeTime}
              resourceChangeTime={resourceChangeTime}
              eventViews={bs4EventViewArrayL1} 
              layer={1}
              lines={lines}
              uxBodyEvent={props.uxBodyEvent}
              onRowClick={props.onRowClick}
              scrollBy={scrollBy}
            />
          : null}

          {report.bs4Timeline.layer0 ? 
            <report.ViewResourceLayer
              resource={props.resource}
              timelineChangeTime={props.timelineChangeTime}
              resourceChangeTime={resourceChangeTime}
              eventViews={bs4EventViewArrayL0}
              layer={0}
              lines={lines}
              uxBodyEvent={props.uxBodyEvent}
              onRowClick={props.onRowClick}
              scrollBy={scrollBy}
            />
          : null}
          {activeEvent ? 
            <report.ViewResourceLayer
              resource={props.resource}
              timelineChangeTime={props.timelineChangeTime}
              resourceChangeTime={resourceChangeTime}
              eventViews={[activeEvent]}
              layer={-1}
              lines={lines}
              uxBodyEvent={props.uxBodyEvent}
              onRowClick={props.onRowClick}
              activeChangeTime={activeChangeTime}
            />
          : null}          
          {smallScreen ? 
            <Typography 
              variant='body2'
              sx={{ 
                position:'absolute',
                top: 0,
                left: 0,    
                pointerEvents: 'none',
                // zIndex: 2000,
                // backgroundColor: '#ffffff66',
                // boxShadow: '0 0 4px 4px #ffffff66',
                textShadow: '3px 3px #ffffff',
                opacity: 0.7,
              }}
            >
              {props.resource.Name} 
            </Typography>
          : null}
        </Box>
      </Box>
    )
  });

  ViewTimeline = React.memo((props) => {
    const report = this;    
    const [cursor, setCursor] = React.useState(null);
    const refTop = React.useRef(null);
    const ref = React.useRef(null);
    // const resizeObserver = useResizeObserver(ref);
    const [scrollState, setScrollState] = React.useState(null);
    // const scrollWidth = React.useMemo(() => {
    //   if (ref.current) return ref.current.offsetWidth - ref.current.clientWidth - 1;
    //   return 0;
    // }, [ref.current, resizeObserver]);

    // console.log('...ViewTimeline...', report.bs4Timeline.resources.length, scrollWidth)
    
    React.useEffect(() => {            
      let previousScrollTop = 0;
      const setNewScrollState = (force) => {
        const scrollState = {
          clientHeight: ref.current?.clientHeight, 
          scrollTop: ref.current?.scrollTop, 
          scrollHeight: ref.current?.scrollHeight,
          rect: ref.current?.getBoundingClientRect(),
        }                
        previousScrollTop = scrollState.scrollTop;
        // if (!Boolean(ref.current)) console.log('...sss...', Boolean(ref.current), scrollState)
        setScrollState(scrollState);
      }
      
      let scrollTimeout = null;
      const onScroll = (e) => {
        clearTimeout(scrollTimeout);
        const f = this.scrollMargin * 1 / 2;
        if (Math.abs(previousScrollTop - ref.current.scrollTop) > this.bs4Timeline.bs4EventHeight * f) {
          setNewScrollState();
        } else {
          scrollTimeout = setTimeout(() => {
            setNewScrollState();
          }, 33);
        }            
      }

      ref.current?.addEventListener('scroll', onScroll);
      setNewScrollState(true);

      return () => ref.current?.removeEventListener('scroll', onScroll);
    }, [ref.current, setScrollState])

    React.useEffect(() => {      
      if (props.setScrollTarget) props.setScrollTarget(ref.current, 'grid');
    }, [ref.current]);

    // console.log('...ViewTimeline...', Bs4Utils.toDateTime(props.timelineChangeTime))
    // console.log('...ViewTimeline...resourceArray', report.bs4Timeline.resourceArray.length, report.bs4Timeline.resourceArray)

    return (
      <report.ScrollContext.Provider value={scrollState}>
      <Box
        id='ViewTimeline'
        ref={refTop} 
        sx={{
          flex: 1,
          display: 'grid',
          gridTemplateColumns: 'min-content 4px 1fr auto',
          // gridTemplateColumns: 'min-content 4px minmax(600px, 1fr) auto',
          gridTemplateRows: 'minmax(0px, max-content) 1fr',
          overflowY: 'hidden',
          overflowX: 'auto',
          userSelect: 'none',
          cursor: cursor,
        }}
      >
        <report.ViewLeftColumnWidthResize setCursor={setCursor}/>
        <report.ViewHeader timelineChangeTime={props.timelineChangeTime}/>
        <Box 
          id='ViewResourceArray'
          ref={ref}
          sx={{
            display: 'grid', 
            gridColumn: '1 / 5', 
            gridRow: '2/3',            
            gridTemplateColumns: 'subgrid', 
            overflowY: 'auto',
            overflowX: 'hidden',
            ...report.bs4Timeline.borderLeft,            
          }}
        >
          {report.bs4Timeline.resourceArray.map(resource => {
            return (
              <report.ViewResource 
                key={resource.key} 
                timelineChangeTime={props.timelineChangeTime}
                uxBodyEvent={props.uxBodyEvent}
                resource={resource}
                onRowClick={props.onRowClick}
                refScroll={refTop}
              />
            )
          })}
        </Box>
      </Box>
      </report.ScrollContext.Provider>
    )
  });  

  customCollisionDetectionAlgorithm = (props) => {
    const {droppableContainers, droppableRects, ...args} = props

    const collisions = [];    
    for (const droppableContainer of droppableContainers) {
      const {id} = droppableContainer;
      if (!droppableContainer.node.current) {
        // console.log('...???...collisions', droppableContainer);
      }
      const rect = droppableContainer.node.current.getBoundingClientRect();
      const pointerCoordinates = props.pointerCoordinates;      
      droppableContainer.data.current.droppableRef.rect = rect;
      droppableContainer.data.current.droppableRef.pointerCoordinates = pointerCoordinates;
      if (rect) {
        let v = 9999;
        if (rect.left <= pointerCoordinates.x && rect.top <= pointerCoordinates.y && rect.right >= pointerCoordinates.x && rect.bottom >= pointerCoordinates.y) {
          v = 0;
        }

        droppableContainer.data.current.droppableRef.isIn = Boolean(v === 0);
        droppableContainer.data.current.droppableRef.pointerCoordinates = pointerCoordinates;
        collisions.push({id, data: {droppableContainer, value: v}});        
      }
    }

    const sortedCollisions  = collisions.sort(({data: {value: a}}, {data: {value: b}}) => a - b);    
    return sortedCollisions;
  };

  ViewComponent = (props) => {
    const report = this;
    const [timelineChangeTime, setTimelineChangeTime]  = React.useState(new Date());
    const modifiers = React.useMemo(() => {      
      const modifiers = [VIEW_TYPE_MODIFIER_LAYER0, VIEW_TYPE_MODIFIER_LAYER1];
      // Tekst na button ma przeciwne znaczenie.
      if (!this.bs4Timeline.adjustmentToUnitWidth) modifiers.push(VIEW_TYPE_MODIFIER_ADJUSTMENT_TO_UNIT_WIDTH);
      return modifiers;
    }, [props.viewButtons, this.bs4Timeline.adjustmentToUnitWidth])
    
    const [active, setActive] = React.useState(null);
    const [cursor, setCursor] = React.useState(null);
    const [displayWait, setDisplayWait] = React.useState(false);
   
    const sensors = useSensors(
      useSensor(KeyboardSensor),
      useSensor(PointerSensor, {
        activationConstraint: {
          distance: 10,
          delay: 300,
          tolerance: 15,
        },
      }),
      useSensor(TouchSensor),
    );
    
    React.useEffect(() => {
      this.fetchMore = props.fetchMore;      
    }, [props.fetchMore]);    

    React.useEffect(() => {
    }, [props.initialView])    

    React.useEffect(() => {
      this.setTimelineChangeTime = (tlct) => {
        // console.log('....Bs4ReportTimeline...setTimelineChangeTime...', Bs4Utils.toDateTime(tlct))
        setTimelineChangeTime(tlct);
      }
      this.updateScope();
      this.setDisplayWait = setDisplayWait;
    }, [setTimelineChangeTime, this.updateScope, setDisplayWait]);
    
    const handleDragStart = (event) => {      
      const draggableProps = event.active.data.current;
      // console.log('...DragStart...', event, {...draggableProps})
      draggableProps.setActive(true);
      setActive(draggableProps);
      // setTimelineChangeTime(new Date())
      if (navigator.vibrate) navigator.vibrate(1);
    }

    const handleDragMove = (event) => {            
      // console.log('...DragMove...', event.over?.data?.current?.droppableRef?.isIn, event, active)      
      if (!active) {
        return;
      }
      if (!event.over?.data?.current?.setBs4ActiveMove) {
        return;
      }
      if (active && event.over?.data?.current?.droppableRef?.isIn) {
        event.over.data.current.setBs4ActiveMove(active, event.over);
      }
    }

    const handleDragEnd = (event) => {
      const bs4Event = active.props?.bs4Event;      
      if (bs4Event) {
        setActive(null);        
        this.bs4Timeline.apiDict[bs4Event.parentKey].updateEnd(bs4Event);
        delete bs4Event.move;
      }      
    }    

    const handleDragCancel = (event) => {
      const bs4Event = active.props?.bs4Event
      active.setActive(false);
      setActive(null);
      if (bs4Event) {        
        this.bs4Timeline.apiDict[bs4Event.parentKey].updateRemove(bs4Event);
        bs4Event.start = bs4Event.move.start;
        bs4Event.end = bs4Event.move.end;
        bs4Event.duration = bs4Event.move.duration;
        bs4Event.ResourceId = bs4Event.move.ResourceId;
        bs4Event.parentKey = bs4Event.move.parentKey;
        delete bs4Event.move;
        this.bs4Timeline.apiDict[bs4Event.parentKey].updateAdd(bs4Event);
      } else {
        console.log('...handleDragCancel...ERROR', active);
      }      
      // setTimelineChangeTime(new Date())
    }

    // console.log('...Bs4ReportTimeline..', cursor)

    return (
      <Box 
        sx={{
          position: 'relative',
          flex: 1,
          display: 'flex',
          flexDirection: 'column',          
          m: 1, 
          width: '100%', 
          overflow: 'hidden',
          cursor: cursor,
        }}
      >              
        <DndContext 
          onDragStart={handleDragStart}         
          onDragEnd={handleDragEnd}          
          onDragCancel={handleDragCancel}
          onDragMove={handleDragMove}
          // onDragOver={handelOver}
          sensors={sensors}
          collisionDetection={report.customCollisionDetectionAlgorithm}
        >
          <report.ViewTimeline 
            timelineChangeTime={timelineChangeTime}
            uxBodyEvent={props.uxBodyEvent}
            onRowClick={props.onRowClick}
            setScrollTarget={props.setScrollTarget}
          />
          <report.ViewFooter 
            uxBodyFooter={props.uxBodyFooter}
            onShow={props.onShow}
            onRemember={props.onRemember}
            onReset={props.onReset}
            viewButtons={props.viewButtons}
            modifiers={modifiers}
          />
          <report.ViewOptions 
            columnsMenu={props.columnsMenu} 
            onMenuClick={props.onMenuClick}
            uxBodyOption={props.uxBodyOption} 
            uxBodyEvent={props.uxBodyEvent}
          />
          {/* <DragOverlay>{active ? <ViewBs4EventDragOverlay {...active.props}/> : null}</DragOverlay> */}
          {active ? <ViewBs4EventDragOverlay {...active.props}/> : null}
        </DndContext>
        <Stack
          sx={{
            display: displayWait ? null : 'none',
            position: 'absolute',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundColor: '#00000022',
          }}
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={2}
        >
          <CircularProgress/>
        </Stack>
      </Box>
    );        
  }
}